import {Box} from '@primer/react'
import {CommentDivider} from '@github-ui/commenting/CommentDivider'
import {CommentLoading} from '@github-ui/commenting/CommentLoading'

import {VALUES} from '../constants/values'

export const IssueTimelineLoading = ({rowCount = VALUES.rowLoadingSkeletonCount}: {rowCount?: number}) => {
  return (
    <Box>
      <CommentDivider />
      {[...Array(rowCount)].map((_, index) => (
        <Box key={index}>
          <CommentLoading />
          <CommentDivider />
        </Box>
      ))}
    </Box>
  )
}

try{ IssueTimelineLoading.displayName ||= 'IssueTimelineLoading' } catch {}